import { type ComponentsOverrides } from '@mui/material/styles'

export const overridesSelect = (): ComponentsOverrides['MuiSelect'] => ({
  select: {
    '&:focus': {
      backgroundColor: 'none',
    },
  },
})
